import { render, staticRenderFns } from "./PricingView.vue?vue&type=template&id=4f2e6e6f&scoped=true"
import script from "./PricingView.vue?vue&type=script&lang=js"
export * from "./PricingView.vue?vue&type=script&lang=js"
import style0 from "./PricingView.vue?vue&type=style&index=0&id=4f2e6e6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2e6e6f",
  null
  
)

export default component.exports